<template>
  <v-card v-if="order" outlined max-width="400" class="mb-5">
    <v-card-title>
      <v-btn
        v-if="order.instruction"
        class="my"
        small
        color="success"
        outlined
        @click="displayInstruction = true"
      >
        仕様書をみる
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <div class="mb-5">
        <span class="caption font-weight-bold"> クエリ </span>
        <v-divider />
        <p class="body-1 mt-2">
          {{ order.query }}
        </p>
      </div>
      <div class="mb-5">
        <span class="caption font-weight-bold"> キーワード </span>
        <v-divider />
        <div class="mt-2 pl-3">
          <div v-for="(words, rank) in order.rankKeywords" :key="rank">
            <span class="caption"> {{ rank }}ランク </span>
            <v-divider />
            <p class="body-1 mt-2">
              <span v-for="word in words" :key="word">
                {{ word }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="mb-5">
        <span class="caption font-weight-bold"> 最低文字数 </span>
        <v-divider />
        <p class="body-1 mt-2">{{ order.requiredWords }}文字</p>
      </div>
      <div class="mb-5">
        <span class="caption font-weight-bold"> 締め切り </span>
        <v-divider />
        <p class="body-1 mt-2">
          {{ order.expiredOn | moment }}
        </p>
      </div>
    </v-card-text>
    <v-dialog v-model="displayInstruction" max-width="600">
      <v-card>
        <v-card-title> 仕様書 </v-card-title>
        <v-card-text>
          <div v-if="order.instruction">
            <v-divider />
            <p class="mt-2 body-2">
              <markdown-preview :source="order.instruction" />
            </p>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
import MarkdownPreview from '@/components/commons/MarkdownPreview'

export default {
  components: {
    MarkdownPreview
  },
  filters: {
    moment: function (date) {
      if (date == null) {
        return ''
      }
      return moment(date).format('YYYY年M月D日')
    }
  },
  data () {
    return {
      displayInstruction: false
    }
  },
  computed: {
    ...mapState({
      order: (state) => state.PostEditor.post.recentOrder
    })
  }
}
</script>

<style scoped></style>
